import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as conversations from '../../conversations'

export const RESOURCE = {
  payload: {
    description:
      'A single info entry of a message. Its subject is the message it belongs to.',
    dimension: conversations.RESOURCE.payload,
    name: 'Message Info',
    partialId: PartialId.Standard.create('message_info'),
  },
  type: core.quiver.Resource.Type.DmsSnapshot,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsSnapshot>

export const MODEL_ID = core.dms.models.Snapshot.Id.from({
  context: core.dms.models.Snapshot.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
